import { onMounted, reactive, watch, toRaw, ref } from "vue";
import DT from "@/services/DT";
import Helper from "@/services/Helper";

export function useFilter(props, { emit }) {
    const shopOptions = ref(false);
    const readyComponent = ref(false);
    const bootData = reactive({
        search: '',
        date: [],
        users: [],
        categories: [],
        is_moderate: null,
        themes: [],
        wishlists: []
    });

    const resetBootData = (val) => {
        bootData.search = val.search ?? '';
        bootData.date = val.date ?? [];
        bootData.users = val.users ?? [];
        bootData.categories = val.categories ?? [];
        bootData.is_moderate = val.is_moderate ?? null;
        bootData.themes = val.themes ?? [];
        bootData.wishlists = val.wishlists ?? [];
    };

    const onFilter = (auto = false) => {
        emit("onFilter", getResult(auto));
    };

    const getResult = (auto) => {
        const date = forDateResult(bootData.date)
        
        return {
            auto,
            search: bootData.search,
            date: { from: date[0], to: date[1] },
            users: bootData.users,
            categories: bootData.categories,
            is_moderate: bootData.is_moderate,
            themes: bootData.themes,
            wishlists: bootData.wishlists,
        };
    };

    const forDateResult = (date) => {
        if (Helper.isEmpty(date)) return [null, null];

        const from = new DT(date[0]).startTimeOfDay();
        const to = new DT(date[1]).endTimeOfDay();

        from.setMonth(from.getMonthNatural());
        to.setMonth(to.getMonthNatural());

        const format = "%Y-%M-%D %H:%I:%S";
        return [from.get(format), to.get(format)];
    };

    const events = {
        onSearch: onFilter,
        applyDate: onFilter,
        onUser: onFilter,
        onCategories: onFilter,
        onIsModerate: onFilter,
        onThemes: onFilter,
        onWishlists: onFilter,
    };

    watch(() => props.params, (val) => {
        resetBootData(toRaw(val));
        onFilter(true);
    }, { immediate: true });

    onMounted(() => {
        readyComponent.value = true;
    });

    return {
        events,
        bootData,
        isEnable: () => props.enable === true,
        isReadyComponent: () => readyComponent.value === true,
        showOptions: () => { shopOptions.value = !shopOptions.value; },
        isShowOptions: () => shopOptions.value,
    };
}
